import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    pageTitle: null,
    breadcrumbs: [],
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    currentPageTitle: state => state.pageTitle,
    currentBreadcrumbs: state => state.breadcrumbs,
  },
  mutations: {
    UPDATE_CURRENT_PAGE_TITLE(state, val) {
      state.pageTitle = val
    },
    UPDATE_CURRENT_BREADCRUMBS(state, val) {
      state.breadcrumbs = val
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
  },
  actions: {},
}
